<template>
  <div class="w-100">
    <div class="accordion">
      <b-card no-body>
        <b-card-header @click="setIsOpen" header-tag="header" role="tab">
          <div class="row">
            <div class="col-6 accordion__title">
              <b-icon
                  icon="arrow-down-short"
                  variant="dark"
              >
              </b-icon>
              <strong>
                {{ $t('modal.segment.group_rule_title') }}
              </strong>
            </div>
            <div class="d-flex justify-content-end align-items-center col-6 text-right">
              <p v-if="isEdited" class="text-danger mr-5 mb-0">{{ $t('error.segment.segment_is_edited') }}</p>
              <p v-if="v.$invalid && v.$anyDirty" class="text-danger mr-5 mb-0">{{ $t('error.segment.segment_required') }}</p>
              <button @click="destroy" class="btn btn-xs btn-danger delete-translation-btn">{{ $t('btn.segment.delete_segment') }}</button>
            </div>
          </div>
        </b-card-header>
        <b-collapse :visible="isOpen" accordion="group" role="tabpanel">
          <div style="height: 400px;">
            <div class="row p-4 d-flex justify-content-center align-items-start">
              <div class="col-6">
                <p>{{$t('segment.set_operation')}}</p>
              </div>
              <div class="col-6">
                <b-form-select v-model="operation" @change="emitSelectedValue('operation')" :state="!v.operation.$dirty ? null :(!v.operation.$error)" :options="options.operation"></b-form-select>
                <div class="">
                  <p v-if="v.operation.$dirty && v.operation.$invalid" class="text-danger">{{ $t('error.required') }}</p>
                </div>
              </div>
            </div>
            <div class="row p-4 d-flex justify-content-center align-items-start">
              <div class="col-6">
                <p>{{$t('segment.set_segment')}}</p>
              </div>

              <div class="col-6">
                <multiselect
                    @input="emitSelectedValue('groupId')"
                    :state="!v.groupId.$dirty ? null :(!v.groupId.$error)"
                    v-model="groupId"
                    :options="options.segments"
                    track-by="value"
                    label="text"
                    :multiple="false">
                </multiselect>
                <div class="">
                  <p v-if="v.groupId.$dirty && v.groupId.$invalid" class="text-danger">{{ $t('error.required') }}</p>
                </div>
              </div>

            </div>
            <div class="row pr-4 d-flex justify-content-center align-items-start">
              <div class="col-12">
                <button v-if="isEditType" :disabled="!isEdited" @click="saveEditedRule" class="float-right btn btn-xs btn-success">{{ $t('btn.segment.save_edited_rule') }}</button>
              </div>
            </div>
          </div>
        </b-collapse>
      </b-card>
    </div>
  </div>
</template>

<script>
import {userSegment} from "../../../../common/constants/userSegment";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect
  },
  props: {
    v: {
      type: Object,
      required: true
    },
    isStaticType: {
      type: Boolean,
      required: true
    },
    groupForm: Object,
    isEditType: {
      type: Boolean,
      default: false
    },
    ruleId: {
      type: String,
      default: null,
      required: false
    },
    methodPost: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    isEdited: function () {
      return this.$store.getters[`userSegment/getEditedRule`](userSegment.group);
    }
  },
  mounted() {
    this.$parent.$on('checkValidation', () => {
      this.v.$touch();
    });

    const isStatic = this.isStaticType ? 1 : 0;

    this.$store.dispatch('userSegment/loadSegmentsByType', isStatic).then(resp => {
      this.options.segments = resp.data.items.map(item => {
        const option = {
          value: item.id,
          text: item.name
        }
        return option;
      });
    });
  },
  data() {
    return {
      isOpen: false,
      groupId: '',
      operation: '',
      options: {
        segments: [],
        operation: [
          {value: 'EQ', text: this.$t('segment.option.equal')},
          {value: 'NEQ', text: this.$t('segment.option.not_equal')}
        ]
      }
    }
  },
  methods: {
    saveEditedRule() {
      this.$parent.$emit('editRule', {type: userSegment.group, ruleId: this.ruleId, methodPost: this.methodPost});
    },
    deleteSegmentRule() {
      this.$parent.$emit('deleteSegmentRule', this.ruleId);
    },
    destroy() {
      const data = {
        component: this,
        rule: userSegment.group,
        ruleId: this.ruleId
      }

      this.$parent.$emit('removeGroup', data);
    },
    setIsOpen() {
      if(this.isEditType && !this.isEdited) {
        this.isOpen = !this.isOpen;
        return;
      } else if(this.isEditType && this.isEdited) {
        return;
      }

      this.isOpen = !this.isOpen;
    },
    emitSelectedValue(type) {
      if(this.isEditType) {
        const data = {
          key: userSegment.group,
          value: true
        }

        this.$store.commit('userSegment/setEditedRule', data);
      }

      this.$parent.$emit('selectedGroup', {type: type, groupId: this.groupId.value, operation: this.operation});
    }
  }
}
</script>